import { Component, EventEmitter, Inject, Input, OnDestroy, Output } from '@angular/core';
import { NgbModal, NgbOffcanvas, OffcanvasDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { Logger } from 'src/app/util/logger';
import { ENV_CONFIG, EnvironmentConfig } from '../../../environments/environment.model';
import { CompanyAccess, MenuItem, UserProfile } from '../../models';
import { ManagementComponent } from '../../modules/shared/management/management.component';
import { AuthorizationGroups } from 'src/app/util/groups.enum';

@Component({
  selector: 'tdw-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnDestroy {
  @Input() appName?: string;
  @Input() userProfile?: UserProfile;
  @Input() currentAccess?: CompanyAccess;
  @Input() brandImageUrl?: string = 'https://assets.tdwilliamson.com/img/CircleMark-PNG.png';
  @Input() isCollapsed: boolean = true;
  @Input() url = '';
  @Input() menuItems: MenuItem[] = [];
  @Input() isHandheld: boolean = false;
  @Input() version?: string;

  @Output() search = new EventEmitter<string>();
  @Output() removeCachedItem = new EventEmitter<string>();
  @Output() logout = new EventEmitter();
  @Output() toggleSidebar = new EventEmitter();

  GROUPS = AuthorizationGroups;

  unsubscribe$ = new Subject();

  constructor(
    private modalService: NgbModal,
    @Inject(ENV_CONFIG) private config: EnvironmentConfig) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  showManagementModal(): void {
    const modal = this.modalService.open(ManagementComponent, { ...this.config.modalOptions });
    modal.componentInstance.userProfile = this.userProfile;
    modal.componentInstance.removeCachedItem.pipe(takeUntil(this.unsubscribe$)).subscribe((item: string) => this.removeCachedItem.emit(item));
    modal.componentInstance.logout.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.logout.emit());
  }
}
